import { noop } from 'lodash-es';
import PropTypes from 'prop-types';
import React from 'react';
import compose from 'recompose/compose';
import toClass from 'recompose/toClass';
import { VelocityTransitionGroup } from 'velocity-react';
import disableiOSScroll from '../hocs/disableiOSScroll';
var OverlayBackground = function (_a) {
    var colour = _a.colour, animate = _a.animate, animationDuration = _a.animationDuration, onClick = _a.onClick;
    var overlay = (React.createElement("div", { className: "position-absolute pinAll", onClick: onClick, style: { backgroundColor: colour } }));
    if (animate) {
        return (React.createElement(VelocityTransitionGroup, { enter: {
                animation: { opacity: 1 },
                duration: animationDuration,
                easing: 'ease',
            }, leave: {
                animation: { opacity: 0 },
                duration: animationDuration,
                easing: 'ease',
            }, runOnMount: true }, colour ? overlay : undefined));
    }
    return !!colour && overlay;
};
OverlayBackground.propTypes = {
    colour: PropTypes.string,
    animate: PropTypes.bool,
    animationDuration: PropTypes.number,
    onClick: PropTypes.func.isRequired,
};
OverlayBackground.defaultProps = {
    onClick: noop,
};
export default compose(disableiOSScroll, toClass)(OverlayBackground);
